import { render, staticRenderFns } from "./TourPage.vue?vue&type=template&id=5ac32a80&scoped=true"
import script from "./TourPage.vue?vue&type=script&lang=js"
export * from "./TourPage.vue?vue&type=script&lang=js"
import style0 from "./TourPage.vue?vue&type=style&index=0&id=5ac32a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac32a80",
  null
  
)

export default component.exports